import {Gearbox} from "@App/types";
import React, {PureComponent, StrictMode} from "react";
import {GearboxListItem} from "@App/Components/Vehicletree/GearboxList";

type GearboxListProps = {
    gearboxes: Gearbox[]
    onClick: (gearbox: Gearbox) => void
}

export class GearboxList extends PureComponent<GearboxListProps> {
    render() {
        return (
            <StrictMode>
                <div className="mt-5">
                    {this.props.gearboxes && this.props.gearboxes.map((gearbox, index) => (
                        <GearboxListItem
                            key={index}
                            gearbox={gearbox}
                            onClick={this.props.onClick}
                        />
                    ))}
                </div>
            </StrictMode>
        );
    }
}
